import React, { Component } from "react";
import { Layout, notification } from "antd";
import {withRouter, Redirect, Route, Switch, BrowserRouter} from "react-router-dom";

import AppHeader from "components/layout/AppHeader";
import LoadingIndicator from "components/LoadingIndicator";
import PrivateRoute from "components/PrivateRoute";
import AppSidebar from "components/layout/AppSidebar";

import SendMoneyPage from "pages/sendmoney/SendMoneyPage";
import ManageOrderPage from "pages/manageorder/ManageOrderPage";
import ManageBeneficiariesPage from "pages/managebeneficiary/ManageBeneficiariesPage";
import ManageProfilePage from "pages/manageprofile/ManageProfilePage";
// import SettingsPage from "pages/SettingsPage";
import VerificationPage from "pages/VerificationPage";
import LoginPage from "pages/LoginPage";
import SignUpPage from "pages/SignUpPage";
import ResetPasswordPage from "pages/ResetPasswordPage";
import ForgotPasswordPage from "pages/ForgotPasswordPage";
import EnterPhoneNumberPage from "pages/EnterPhoneNumberPage";
import EnterOTPPage from "pages/EnterOTPPage";
import { getCurrentCustomer } from "api/api";
import classNames from "classnames";
import get from "lodash/get";

import "common/app.scss";
import "common/reset.css";
import "./PaymentsApplication.scss";
import ManageOriginatorsPage from "../pages/manageoriginator/ManageOriginatorsPage";
import {getGeoLocation, logout} from "../api/api";
import ClientTransferCalculatorSignUp from "../components/transfercalculator/ClientTransferCalculatorSignUp";
import CustomerTierCalculatorPage from "../pages/CustomerTierCalculatorPage";

// RX Pages
import DashboardRxPage from "rxpages/DashboardRxPage";
import TransactionHistoryRxPage from "rxpages/TransactionHistoryRxPage";

import ReportPage from "../pages/report/ReportPage";
import {BatchUploadPage} from "../pages/batch/BatchUploadPage";

import {connect} from "react-redux";
import {loginSuccess} from "../rx/user/userAction";
import withUseIntl from "../components/withUseIntl";
import jwt_decode from "jwt-decode";
import {displayError, displayWarningMessage, displayWarningMessageWithSeconds} from "../common/notifications";

const { Content } = Layout;

class App extends Component {
  state = {
    currentCustomer: null,
    isAuthenticated: false,
    isLoading: true,
      countryCodeFromIp:'SG',
  };

  constructor(props) {
    super(props);
    notification.config({
      placement: "topRight",
      top: 70,
      duration: 3
    });
  }
    componentWillUnmount() {
        clearInterval(this.intervalId);
    }
    componentDidMount() {
        this.loadCurrentCustomer();
        let hours = 0.1; //expires in 6 minutes
        let now = Date.now();
        let setupTime = localStorage.getItem('setupTimeCallGetCountryCode');
        if (setupTime == null) {
            localStorage.setItem('setupTimeCallGetCountryCode', now)
            this.loadGeoLocation();
        } else if (now - setupTime > hours * 60 * 60 * 1000) {
            localStorage.setItem('setupTimeCallGetCountryCode', now)
            this.loadGeoLocation();
        }
        this.intervalId = setInterval(() => {
            try {

                if (localStorage.getItem("ACCESS_TOKEN") != null) {
                    let decoded = jwt_decode(localStorage.getItem("ACCESS_TOKEN"));
                    let current_time = new Date().getTime() / 1000;
                    let temp = decoded.exp - current_time;
                    if(temp > 0 && temp < 300){
                        displayWarningMessageWithSeconds("Your session will expire within the next few minutes,, please touch in any menu for extends your session", 28)
                    }
                }
            } catch (e) {

            }
        }, 30000);
    }

  handleLogout = (
    redirectTo = "/",
    notificationType = "success",
    description = "You're successfully logged out."
  ) => {
      logout().then(r => {
          localStorage.removeItem("ACCESS_TOKEN");

          this.setState({
              currentCustomer: null,
              isAuthenticated: false
          });

          this.props.history.push(redirectTo);

          notification[notificationType]({
              message: "Brdgx",
              description: description
          });
      }) .catch(error => {
          localStorage.removeItem("ACCESS_TOKEN");

          this.setState({
              currentCustomer: null,
              isAuthenticated: false
          });


          this.props.history.push(redirectTo);

          notification[notificationType]({
              message: "Brdgepay",
              description: description
          });
      });

  };

  handleLogin = () => {
    notification.success({
      message: "Brdgx",
      description: "You're successfully logged in."
    });
    this.loadCurrentCustomer().then(_ => this.props.history.push("/"));
  };
    loadGeoLocation = () => {
        localStorage.removeItem("countryCode")
        return getGeoLocation()
            .then(response => {
                try {
                    localStorage.setItem("countryCode", response.country_code2);
                } catch (error) {
                    localStorage.setItem("countryCode",'SG');
                }
            })
            .catch(error => {
                localStorage.setItem("countryCode",'SG');
            });
    }
  loadCurrentCustomer = () => {
    this.setState({
      isLoading: true
    });
    return getCurrentCustomer()
      .then(response => {
        let currentCustomer = response;
        currentCustomer.isPartner = (response['customerTierName'] && response['customerTierName'].includes('PARTNER'));
        this.setState({
          currentCustomer: currentCustomer,
          isAuthenticated: true,
          isLoading: false
        });
        this.props.pushCurrentUser(currentCustomer)
      })
      .catch(error => {
          if(error.status === 401){
              //incase token is not valid then remove access token
              localStorage.removeItem("ACCESS_TOKEN");

          }
        this.setState({
          isLoading: false
        });
      });
  };

  handleBettingSwitchChange(newValue) {
    this.setState({
      isLoading: true
    });
  }

  handleSubmitOtp(e) {
    this.setState({
      isAuthenticated: true
    });
  }

  layout(content) {
    const { isAuthenticated, currentCustomer } = this.state;
    // if(window.location.pathname === "/pages/onboarding/myinfo/complete") {
    //     const search = window.location.search;
    //     const params = new URLSearchParams(search);
    //     if( params.get("error-description") && params.get("error") && params.get("state")){
    //         window.localtion = "/pages/onboarding";
    //     }
    // }

    const isSidebarVisible =
      isAuthenticated &&
      currentCustomer &&
      (currentCustomer.loginStatus !== "NO_LOGIN" &&
          currentCustomer.loginStatus !== "PHONE_NUMBER_REQUIRED" &&
        currentCustomer.loginStatus !== "PHONE_VERIFICATION_REQUIRED" &&
        currentCustomer.loginStatus !== "EMAIL_VERIFICATION_REQUIRED" &&
        !window.location.toString().endsWith("onboarding"))&&
        (window.location.pathname !== "/pages/onboarding/myinfo/complete");

    const accountStatus = get(this.state.currentCustomer, "status", null);
    let isDisplayVerifyBar = false;
    if (
      window.location.pathname === "/pages/transfer/" ||
      window.location.pathname === "/pages/order"
    ) {
      isDisplayVerifyBar =
        accountStatus === "UNVERIFIED" || accountStatus === "REVIEW_REQUIRED" || accountStatus === "PENDING";
    }

    return (
        <BrowserRouter>

              <Layout
                className={classNames("app-container", {
                  "verify-bar": isDisplayVerifyBar
                })}
              >
                <AppHeader
                  isAuthenticated={isAuthenticated}
                  currentCustomer={currentCustomer}
                  onLogout={this.handleLogout}
                  onSignIn={this.handleLogin}
                />
                {isSidebarVisible && <AppSidebar currentCustomer={this.state.currentCustomer} onSignOut={this.handleLogout} />}

                <Content className="app-content">
                  <div className="app-content-wrapper">{content}</div>
                </Content>
              </Layout>
        </BrowserRouter>
    );
  }

  render() {
    const accountStatus = get(this.state.currentCustomer, "status", null);
    if (this.state.isLoading) {
      return <LoadingIndicator />;
    }

    const { isAuthenticated, currentCustomer } = this.state;

    if (window.location.toString().includes("verify-email")) {
      return <Redirect to="/login?hide-signup-modal=true" />;
    }

    if (
      currentCustomer &&
        (currentCustomer.loginStatus === "PHONE_NUMBER_REQUIRED" || currentCustomer.loginStatus === "NO_LOGIN" ) &&
      !window.location.toString().endsWith("/pages/submit-phone")
    ) {
      return <Redirect to="/pages/submit-phone" />;
    }

    if (
      currentCustomer &&
      currentCustomer.loginStatus === "PHONE_VERIFICATION_REQUIRED" &&
      !window.location.toString().endsWith("/pages/verify-phone")
    ) {
      return <Redirect to="/pages/verify-phone" />;
    }
    let url= "/pages/transfer/";
    
    if(currentCustomer && currentCustomer.approval && currentCustomer.roleResources.filter(s=>s.name === 'APPROVER').length > 0 &&
        currentCustomer.roleResources.filter(s=>s.name === 'CREATOR').length === 0 ){
        url ='/pages/order'
    }
    if (
      currentCustomer &&
      currentCustomer.loginStatus !== "EMAIL_VERIFICATION_REQUIRED"
    ) {

      var isNotReadOnly = this.props.currentUser && !this.props.currentUser.role.readOnly;
      var isReadOnly = this.props.currentUser && this.props.currentUser.role.readOnly;
      var isFullAccess = this.props.currentUser && this.props.currentUser.role.fullAccess;
      var isNotApproval = this.props.currentUser && !this.props.currentUser.approval;
      var isApprovalCreator = this.props.currentUser && this.props.currentUser.approval && this.props.currentUser.role.creator;
        var isBatchUpload = this.props.currentUser && this.props.currentUser.role.batchUpload;

      return this.layout(

        <Switch>
          <Route exact path="/">
            <Redirect to={url} />
          </Route>
          { ( isReadOnly || isFullAccess || isNotApproval || isApprovalCreator) && (
          <PrivateRoute
            exact
            path="/pages/transfer/"
            authenticated={isAuthenticated}
            component={SendMoneyPage}
            customer={currentCustomer}
            handleLogout={this.handleLogout}
          />)}

          <PrivateRoute
            exact
            path="/pages/order"
            authenticated={isAuthenticated}
            component={ManageOrderPage}
            customer={currentCustomer}
            handleLogout={this.handleLogout}
          />

          <PrivateRoute
            exact
            path="/pages/beneficiaries"
            authenticated={isAuthenticated}
            customer={currentCustomer}
            component={ManageBeneficiariesPage}
            handleLogout={this.handleLogout}
          />

            {this.state.currentCustomer.isPartner && <PrivateRoute
                exact
                path="/pages/originators"
                authenticated={isAuthenticated}
                customer={currentCustomer}
                component={ManageOriginatorsPage}
                handleLogout={this.handleLogout}
            />}

          <PrivateRoute
            exact
            path="/pages/profile"
            authenticated={isAuthenticated}
            customer={currentCustomer}
            component={ManageProfilePage}
            handleLogout={this.handleLogout}
          />
            <PrivateRoute
                exact
                path="/pages/report"
                authenticated={isAuthenticated}
                customer={currentCustomer}
                component={ReportPage}
                handleLogout={this.handleLogout}
            />
            {((this.state.currentCustomer.isPartner && isNotReadOnly) || isBatchUpload) && (
            <PrivateRoute
                exact
                path="/pages/batch/upload"
                authenticated={isAuthenticated}
                customer={currentCustomer}
                component={BatchUploadPage}
                handleLogout={this.handleLogout}
            />)}
          {/*
          <PrivateRoute
            exact
            path="/pages/settings"
            authenticated={isAuthenticated}
            customer={currentCustomer}
            component={SettingsPage}
            handleLogout={this.handleLogout}
          />
          */}

          <PrivateRoute
            exact
            path="/pages/onboarding"
            authenticated={isAuthenticated}
            component={VerificationPage}
            handleLogout={this.handleLogout}
            accountStatus={accountStatus}
            customer={currentCustomer}
          />
        <PrivateRoute
            exact
            path="/pages/onboarding/myinfo/complete"
            authenticated={isAuthenticated}
            component={VerificationPage}
            handleLogout={this.handleLogout}
            accountStatus={accountStatus}
            customer={currentCustomer}
        />


          <PrivateRoute
            exact
            path="/pages/submit-phone"
            authenticated={isAuthenticated}
            component={EnterPhoneNumberPage}
            handleLogout={this.handleLogout}
          />

          <PrivateRoute
            exact
            path="/pages/verify-phone"
            authenticated={isAuthenticated}
            component={EnterOTPPage}
            handleLogout={this.handleLogout}
          />

          <PrivateRoute
            path="/pages/dashboard"
            authenticated={isAuthenticated}
            component={DashboardRxPage}
            handleLogout={this.handleLogout}
            customer={currentCustomer}
          />

          <PrivateRoute
            exact
            path="/pages/transactions"
            authenticated={isAuthenticated}
            customer={currentCustomer}
            component={TransactionHistoryRxPage}
            handleLogout={this.handleLogout}
          />
        </Switch>
      );
    }

    return this.layout(
        // <BrowserRouter>
      <Switch>
        <Route path="/main" component={SignUpPage} />
          {/*<Route path="/rate/:customer_tier" component={CustomerTierCalculatorPage}/>*/}
        <Route path="/forgot-password" component={ForgotPasswordPage} />
        <Route path="/reset-password" component={ResetPasswordPage} />
        <Route
          path="/login"
          render={props => (
            <LoginPage
              isAuthenticated={isAuthenticated}
              onLogin={this.handleLogin}
              {...props}
            />
          )}
        />
        <Route>
          <Redirect to="/main" />
        </Route>
      </Switch>
        // </BrowserRouter>
    );
  }
}

// export default withRouter(App);


const mapStateToProps = (state) => {
    return {
        currentUser: state.user.currentUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        pushCurrentUser: (user) => dispatch(loginSuccess(user)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withUseIntl(App)));
